import { Link } from 'react-router-dom';
import { PageHeader } from '@/components/PageHeader';
import { EmptyState } from '@/components/EmptyState';
import { StatusBadge } from '@/components/StatusBadge';
import { useEvents } from '@/hooks/useDesk';
import { formatDate } from '@/lib/format';
import { formatEventPlace } from '@/types/desk';

export function CalendarPage() {
  const { data, isLoading, isError, error } = useEvents();

  const sorted = [...(data || [])].sort((a, b) => {
    const at = a.starts_at ? Date.parse(a.starts_at) : Number.POSITIVE_INFINITY;
    const bt = b.starts_at ? Date.parse(b.starts_at) : Number.POSITIVE_INFINITY;
    return at - bt;
  });

  return (
    <div>
      <PageHeader
        title="Calendar"
        description="Venue occupancy from domeec_events (ICS export follow-up)."
      />
      {isLoading ? (
        <p className="animate-pulse-soft text-sm text-[var(--muted)]">Loading…</p>
      ) : null}
      {isError ? (
        <p className="text-sm text-dome-danger">{(error as Error).message}</p>
      ) : null}
      {!isLoading && sorted.length === 0 ? (
        <EmptyState
          title="Calendar empty"
          body="Events with start dates appear here. ICS feeds come next."
        />
      ) : null}
      {sorted.length > 0 ? (
        <ol className="space-y-2">
          {sorted.map((ev) => (
            <li
              key={ev.id}
              className="flex flex-wrap items-center justify-between gap-2 rounded-xl border border-[var(--border)] bg-white/80 px-4 py-3"
            >
              <div>
                <p className="font-medium text-dome-forest">
                  <Link
                    to={`/events/${ev.id}`}
                    className="underline-offset-2 hover:underline"
                  >
                    {ev.name}
                  </Link>
                </p>
                <p className="text-xs text-[var(--muted)]">
                  {formatDate(ev.starts_at)}
                  {` · ${formatEventPlace(ev)}`}
                </p>
              </div>
              <StatusBadge status={ev.status} />
            </li>
          ))}
        </ol>
      ) : null}
    </div>
  );
}
